import React from "react";
import MenuItem from "@material-ui/core/MenuItem";

import { useSnackbar } from "components/haven-design/snackbar";
import { useInterestsTable } from "../interests-table/table-context";

interface Props {
  selectedInterestIds: string[];
  closeMenu: () => void;
  setSkipModalOpen: React.Dispatch<React.SetStateAction<boolean>>
}

// eslint-disable-next-line max-lines-per-function
const SkipButton: React.FC<Props> = (props) => {
  const { closeMenu, setSkipModalOpen } = props;
  const { openSnackbar } = useSnackbar();
  const {
    hasSelectedAllInterests,
    totalSelectedInterests,
    selectedPageRange,
  } = useInterestsTable();

  const open = () => {
    const selectedAll = hasSelectedAllInterests;
    const { from, to, totalPages } = selectedPageRange;

    if (totalSelectedInterests === 0) {
      setTimeout(() => openSnackbar({ message: "Please select an applicant to skip.", status: "error", duration: 5000 }), 100);
    } else if (selectedAll || (from === 0 && (to === totalPages - 1))) {
      setTimeout(() => openSnackbar({ message: "Can't skip whole list", status: "error", duration: 5000 }), 100);
    } else {
      setSkipModalOpen(true);
    }
    closeMenu();
  };


  return (
    <MenuItem id="actions-skip-applicants" onMouseUp={open}>
      Skip Applicants {`(${totalSelectedInterests})`}
    </MenuItem>
  );
};

export default SkipButton;
